// Centralized timeout values (milliseconds) to avoid magic numbers
export const TOAST_SUCCESS_MS = 3000; // short success toast
export const TOAST_ERROR_MS = 5000; // default error/info toast
export const TOAST_LONG_MS = 8000; // longer messages that need more time

export default {
  TOAST_SUCCESS_MS,
  TOAST_ERROR_MS,
  TOAST_LONG_MS,
};
